import { render, staticRenderFns } from "./AccountSettingShortcut.vue?vue&type=template&id=312acc69"
import script from "./AccountSettingShortcut.vue?vue&type=script&lang=js"
export * from "./AccountSettingShortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports